import { Spacing } from './../../types/theme';

export const spacing: Spacing = {
	spaceSeven: 48,
	spaceSix: 40,
	spaceFive: 32,
	spaceFour: 24,
	spaceThree: 16,
	spaceTwo: 12,
	spaceOne: 8,
};
